 
import { ERROR_MESSAGE } from '../reducer/status';
import { HEALTH_CHECK_FAILURE } from '../reducer/returnOps';

 
const failure = (dispatch: any, type: string, input: any, message?: string) => (payload: any) => {
    try {
        let parsed: any = {};
        try {
            parsed = JSON.parse(payload.message);
        } catch {
            parsed = payload.response;
        }
        dispatch({
            type,
            ...input,
            data: parsed?.data,
        });

        if (type !== HEALTH_CHECK_FAILURE) {
            dispatch({
                type: ERROR_MESSAGE,
                message: parsed?.data?.responseData ?? message ?? parsed?.data ?? 'Something went wrong.',
            });
        }

        if (input?.onFailure) input.onFailure(parsed);
        if (input?.onError) input.onError(parsed);
    } catch {
        dispatch({
            type,
            ...input,
            data: payload?.data,
        });

        if (type !== HEALTH_CHECK_FAILURE) {
            dispatch({
                type: ERROR_MESSAGE,
                message: message ?? 'Something went wrong!',
            });
        }

        if (input?.onFailure) input.onFailure(payload);
        if (input?.onError) input.onError(payload);
    }
};

export default failure;
